import http from '@/plugins/axios';

export async function get_restaurants(payload) {
  const response = await http.get('g/RESTAURANT?limit=10000&&search=' + payload);
  return response.data;
}

export async function shortcut_template(payload) {
  const response = await http.get('shortcut-keyboard?restaurant_id='+ payload);
  return response;
}